export const STUDENT_CENTRAL_ROUTES = {
	studentCentral: "/student-central",
	studentCentralDetailPattern: "/student-central/:id",
	studentCentralDetail: (id: string) => `/student-central/${id}` as const,
	appStudentCentral: "/app/student-central",
	appStudentCentralDetailPattern: "/app/student-central/:id",
	appStudentCentralDetail: (id: string) => `/app/student-central/${id}` as const,
} as const;
